import script from "./rangeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./rangeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./rangeComponent.vue?vue&type=style&index=0&id=4f30c9ec&lang=css"

const __exports__ = script;

export default __exports__